import { Box, Menu, Title } from "@mantine/core";
import { useAuth } from "../../../../../AuthContext";
import { nameToInitials } from "../../../../../helpers/string.helpers";
import CircleContainer from "../CircleContainer";
import Dropdown from "./components/Dropdown/DropDown";
import classes from "./styles.module.scss";

function ProfileDropdown() {
  const { user } = useAuth();

  return (
    <Menu
      position="bottom"
      trigger="click-hover"
      classNames={{
        dropdown: classes.dropdown,
        item: classes.item,
        itemLabel: classes.itemLabel,
        label: classes.label,
      }}
      closeDelay={800}
    >
      <Menu.Target>
        <Box>
          <CircleContainer>
            <Title order={4} c="white">
              {nameToInitials(`${user?.FirstName} ${user?.LastName}`)}
            </Title>
          </CircleContainer>
        </Box>
      </Menu.Target>
      <Menu.Dropdown>
        <Dropdown />
      </Menu.Dropdown>
    </Menu>
  );
}

export default ProfileDropdown;
